import React, { useEffect, useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Autocomplete,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  Grid,
  Box,
  FormHelperText,
  InputAdornment,
  Tooltip,
  IconButton,
  Dialog,
} from '@mui/material';
import moment from 'moment';
import LoaderComponent from '../../../components/Loader/LoaderComponent';
import '../../../App.css';
import './ReportFilter.css';
import { getUsers } from '../../../services/UserService';
import { useDispatch } from 'react-redux';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Calendar } from 'react-multi-date-picker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { RESET_COLUMN_FILTERS } from '../../../constants';

const ReportFilter = (props) => {
  const {
    filterData,
    setFilterData,
    myLoader,
    setMyLoader,
    reportType,
    refresh,
    setRefresh,
  } = props;
  const [toSubjects, setToSubjects] = React.useState([]);
  const [recipients, setRecipients] = React.useState([]);
  const [search, setSearch] = React.useState(false);
  const [inputValue, setInputValue] = useState('');
  const [reportFilterTypes, setReportFilterTypes] = React.useState([]);
  const dispatch = useDispatch();

  const [isStartDateValid, setisStartDateValid] = useState(true);
  const [isEndDateValid, setisEndDateValid] = useState(true);
  const [startDateError, setStartDateError] = React.useState(null);
  const [endDateError, setendDateError] = React.useState(null);
  const [reportSelectError, setReportSelectError] = useState(false);
  const [durationSelectError, setDurationSelectError] = useState(false);
  const [errorMessageReport, setErrorMessageReport] = useState('');
  const [errorMessageDuration, setErrorMessageDuration] = useState('');
  const [tempFilterData, setTempFilterData] = useState({
    reportType: '',
    users: [],
    columnFilters: [],
  });
  const [filterConfig, setFilterConfig] = useState({});
  const [openPicker, setOpenPicker] = useState(false);
  const [rangeOption, setRangeOption] = useState([
    moment().format('MM/YYYY'),
    moment().format('MM/YYYY'),
  ]);

  useEffect(() => {
    let newTempFilterData;
    switch (tempFilterData.reportType) {
      case 'Holiday Utilisation Report':
        setTempFilterData( {
          columnFilters: [],
          reportType: tempFilterData.reportType,
          year: new Date().getFullYear(),
          minUtilisedHoliday: '0',
          maxUtilisedHoliday: '12',
          users: [],
        });
        break;
  
      case 'Monthly Timings Report':
          setTempFilterData({
            columnFilters: [],
            reportType: tempFilterData.reportType,
            timeSelector: '',
            users: [],
          });
          break;
        
      case 'Monthly Timings Report (old)':
        setTempFilterData({
          columnFilters: [],
          reportType: tempFilterData.reportType,
          timeSelector: '',
          users: [],
        });
        break;
  
      case 'Leaves Encashment Report':
        setTempFilterData({
          columnFilters: [],
          reportType: tempFilterData.reportType,
          year: new Date().getFullYear(),
          users: [],
        });
        break;
        
      default:
        break;
    }
    setRecipients([])
    setFilterData([])

  }, [tempFilterData.reportType]);

  const endDateErrorMessage = React.useMemo(() => {
    switch (endDateError) {
      case 'invalidDate': {
        setisEndDateValid(false);
        return 'Invalid date';
      }
      case 'maxDate': {
        setisEndDateValid(false);
        return 'Please select a date before today';
      }
      case 'minDate': {
        setisEndDateValid(false);
        return 'End date must be greater than the start date';
      }
      default: {
        setisEndDateValid(true);
        return '';
      }
    }
  }, [endDateError]);

  const startDateErrorMessage = React.useMemo(() => {
    switch (startDateError) {
      case 'invalidDate': {
        setisStartDateValid(false);
        return 'Invalid date';
      }
      case 'maxDate': {
        setisStartDateValid(false);
        return 'Please select a date before today';
      }
      default: {
        setisStartDateValid(true);
        return '';
      }
    }
  }, [startDateError]);

  const handleStartDateChange = (startDate) => {
    setTempFilterData({
      ...tempFilterData,
      startDate: startDate.format('YYYY-MM-DD'),
    });
  };
  const handleEndDateChange = (endDate) => {
    setTempFilterData({
      ...tempFilterData,
      endDate: endDate.format('YYYY-MM-DD'),
    });
  };

  const [loader, setLoader] = React.useState(false);
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: 'SHOW_NOTIFICATION',
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const resetToDefaultTimePeriod = () => {
    switch (tempFilterData.timeSelector) {
      case 'Month wise': {
        const ed = moment().format('YYYY/MM/DD').split('/');
        setTempFilterData({
          ...tempFilterData,
          startDate: moment(`${ed[0]}${ed[1]}01`)
            .subtract(1, 'months')
            .format('YYYY-MM-DD'),
          endDate: moment(`${ed[0]}${ed[1]}01`)
            .subtract(1, 'days')
            .format('YYYY-MM-DD'),
        });
        setRangeOption([
          moment(`${ed[0]}${ed[1]}01`).subtract(1, 'months').format('MM/YYYY'),
          moment(`${ed[0]}${ed[1]}01`).subtract(1, 'days').format('MM/YYYY'),
        ]);
        break;
      }
      case 'Custom date wise': {
        const ed = new Date();
        setTempFilterData({
          ...tempFilterData,
          startDate: moment(ed).subtract(1, 'months').format('YYYY-MM-DD'),
          endDate: moment(ed).subtract(1, 'days').format('YYYY-MM-DD'),
        });
        break;
      }
      default:
        break;
    }
  };
  

  useEffect(() => {
    resetToDefaultTimePeriod();
  }, [tempFilterData.timeSelector]);

  const loadData = async () => {
    const subjects = await getUsers('');
    if (subjects.status !== 200) {
      dipatchNotification(subjects.type, subjects.message);
    }
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.content);
      setLoader(false);
    }

    const reportFilterTypes = [
      { value: 'Month wise', label: 'Month wise' },
      { value: 'Custom date wise', label: 'Custom date wise' },
    ];
    setReportFilterTypes(reportFilterTypes);
  };

  const checkOptions = (str) => {
    if (str?.length > 1) {
      setSearch(true);
    } else {
      setSearch(false);
    }
  };

  const handleCloseDropdown = (event) => {
    setSearch(false);
  };

  const handleSubmit = () => {
    if (tempFilterData.reportType === '') {
      setReportSelectError(true);
      setErrorMessageReport('*Required');
    } else if (tempFilterData.timeSelector === '') {
      setDurationSelectError(true);
      setErrorMessageDuration('*Required');
    } else {
      setReportSelectError(false);
      setDurationSelectError(false);
      setErrorMessageReport('');
      setErrorMessageDuration('');
      if (!(isStartDateValid && isEndDateValid)) return;
      setMyLoader(true);
      dispatch({
        type: RESET_COLUMN_FILTERS,
      });
      setFilterData(tempFilterData);
      setRefresh(!refresh);
    }
  };

  const handleMonthRangeChange = (props) => {
    if (props.value.length === 2) {
      setRangeOption(props.value);
      const st = new Date(props.value[0]);
      const ed = props.value[1].toString().split('/');
      setTempFilterData({
        ...tempFilterData,
        startDate: moment(new Date(st)).format('YYYY-MM-DD'),
        endDate: moment(
          `${ed[1]}${ed[0]}${new Date(ed[1], ed[0], 0).getDate()}`,
        ).format('YYYY-MM-DD'),
      });

      setOpenPicker(false);
    }
  };
  const handleRefershClick = (event) => {
    event.stopPropagation();
    resetToDefaultTimePeriod();
  };

  const onTextfieldChanage = (event) => {
    const { name, value } = event.target;

    if (!isNaN(value) && value >= 0) {
      setTempFilterData({
        ...tempFilterData,
        [name]: value,
      });
    }
  };

  return (
    <div>
      {loader ? (
        <div>
          <LoaderComponent loaderType="circular" />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <Box sx={{ flexDirection: 'row', display: 'flex' }}>
            <div sx={{ m: 0, ml: -2 }}>
              <FormControl
                sx={{ minWidth: 260, height: '78px' }}
                variant="outlined"
                error={reportSelectError}
              >
                <InputLabel id="Report Type">Report</InputLabel>
                <Select
                  name="reportType"
                  labelId="Report Type"
                  id="reportType"
                  value={
                    tempFilterData.reportType ? tempFilterData.reportType : ''
                  }
                  label="REPORT"
                  onChange={(event) => {
                    setTempFilterData({
                      ...tempFilterData,
                      timeSelector: '',
                      reportType: event.target.value,
                    });

                    reportType.forEach((val) => {
                      if (val.label === event.target.value) {
                        setFilterConfig(val.config);
                      }
                    });
                  }}
                >
                  {reportType.map((data) => (
                    <MenuItem value={data.label} key={data.id}>
                      {data.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errorMessageReport}</FormHelperText>
              </FormControl>
            </div>

            {filterConfig.monthlyPicker ? (
              <div sx={{ m: 0, ml: -2 }}>
                <FormControl
                  sx={{ ml: 2, mr: 2, minWidth: 260, height: '78px' }}
                  variant="outlined"
                  error={durationSelectError}
                >
                  <InputLabel id="time-selector">Duration</InputLabel>
                  <Select
                    name="timeSelector"
                    labelId="time-selector"
                    id="timeSelector"
                    value={
                      tempFilterData.timeSelector
                        ? tempFilterData.timeSelector
                        : ''
                    }
                    label="Duration"
                    onChange={(event) => {
                      setTempFilterData({
                        ...tempFilterData,
                        timeSelector: event.target.value,
                      });
                    }}
                  >
                    {reportFilterTypes.map((filterType) => (
                      <MenuItem value={filterType.value} key={filterType.value}>
                        {filterType.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errorMessageDuration}</FormHelperText>
                </FormControl>
              </div>
            ) : (
              ''
            )}
            {filterConfig.selectField
              ? filterConfig.selectField.map((field, index) => {
                  return (
                    <FormControl
                      style={{ marginLeft: '15px', width: '200px' }}
                      variant="outlined"
                      key={index}
                    >
                      <InputLabel id="demo-simple-select-label">
                        {field.label}
                      </InputLabel>
                      <Select
                        name="timeSelectorId"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          eval(`tempFilterData.${field.name}`)
                            ? eval(`tempFilterData.${field.name}`)
                            : ''
                        }
                        label={field.label}
                        onChange={(event) => {
                          setTempFilterData({
                            ...tempFilterData,
                            [field.name]: event.target.value,
                          });
                          // setYearSelectError(false);
                          // setErrorMessageYear('');
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300, // Set the maximum height of the dropdown menu
                            },
                          },
                        }}
                      >
                        {field.options.map((year) => (
                          <MenuItem value={year} key={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* <FormHelperText>{errorMessageYear}</FormHelperText> */}
                    </FormControl>
                  );
                })
              : ''}
            {filterConfig.textField
              ? filterConfig.textField.map((field, index) => {
                  return (
                    <FormControl
                      style={{ marginLeft: '15px', width: '200px' }}
                      sx={{ height: '78px' }}
                      variant="outlined"
                      key={index}
                    >
                      <TextField
                        name={field.name}
                        value={
                          eval(`tempFilterData.${field.name}`)
                            ? eval(`tempFilterData.${field.name}`)
                            : ''
                        }
                        onChange={(e) => onTextfieldChanage(e)}
                        id="min-Utilised-Holiday"
                        label={field.label}
                      />
                    </FormControl>
                  );
                })
              : ''}

            {tempFilterData.timeSelector === 'Month wise' && (
              <>
                <TextField
                  // error={payload.rangeError}
                  //   helperText={error[index].monthError}
                  value={rangeOption.join('~')}
                  onClick={() => {
                    setOpenPicker(true);
                  }}
                  label="Month Range"
                  placeholder="Select Month Range"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Referesh">
                          <IconButton onClick={(e) => handleRefershClick(e)}>
                            <RestartAltIcon />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  style={{ height: '57px' }}
                />
                <Dialog
                  open={openPicker}
                  onClose={() => setOpenPicker(false)}
                  PaperProps={{
                    style: {
                      height: '350px',
                    },
                  }}
                >
                  <Calendar
                    placeholder="Select Month Range"
                    onlyMonthPicker
                    range
                    value={rangeOption}
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      height: '38px',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    onPropsChange={(props) => {
                      handleMonthRangeChange(props);
                    }}
                    maxDate={
                      new Date(new Date().setDate(new Date().getDate() - 1))
                    }
                    minDate={moment('1980-01-01', 'YYYY-MM-DD').toDate()}
                  />
                </Dialog>
              </>
            )}

            {tempFilterData.timeSelector === 'Custom date wise' && (
              <>
                <div sx={{ m: 0 }}>
                  <FormControl variant="standard" sx={{ ml: 0, minWidth: 120 }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      sx={{ display: 'none' }}
                    >
                      <DatePicker
                        onError={(newError) => setStartDateError(newError)}
                        id="startDate"
                        label="Start Date"
                        inputFormat="DD/MM/YYYY"
                        value={tempFilterData.startDate}
                        maxDate={tempFilterData.endDate}
                        onChange={handleStartDateChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={!isStartDateValid}
                            helperText={startDateErrorMessage}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </div>
                <div>
                  <FormControl variant="standard" sx={{ ml: 2, minWidth: 120 }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      sx={{ display: 'none' }}
                    >
                      <DatePicker
                        onError={(newError) => setendDateError(newError)}
                        id="endDate"
                        label="End Date"
                        inputFormat="DD/MM/YYYY"
                        value={tempFilterData.endDate}
                        minDate={tempFilterData.startDate}
                        maxDate={tempFilterData.endDate}
                        onChange={handleEndDateChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={!isEndDateValid}
                            helperText={endDateErrorMessage}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </div>
              </>
            )}
          </Box>
          <Box sx={{ flexDirection: 'row', display: 'flex' }}>
            <Grid container spacing={2}>
              <Grid item xs={10.5} style={{ paddingTop: 0 }}>
                <Autocomplete
                  forcePopupIcon={false}
                  multiple
                  disableClearable
                  id="multi-subjects"
                  open={search}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  options={
                    inputValue?.trim() !== ''
                      ? toSubjects.map((subject) => {
                          return {
                            label: `${subject.firstName} ${subject.lastName}`,
                            value: subject.id,
                          };
                        })
                      : []
                  }
                  getOptionLabel={(option) => option.label}
                  onInputChange={(e) => {
                    const inputValue = e?.target?.value;
                    setInputValue(inputValue);
                    checkOptions(inputValue);
                  }}
                  onBlur={handleCloseDropdown}
                  value={recipients || ''}
                  inputValue={inputValue || ''}
                  onChange={(e, val) => {
                    setTempFilterData({
                      ...tempFilterData,
                      users: [
                        ...val.map((v) => {
                          return v.value;
                        }),
                      ],
                    });
                    setRecipients((recipients) => [...val]);
                    setInputValue('');
                    setSearch(false);
                  }}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={'Users'}
                      InputLabelProps={{
                        shrink: !(inputValue === '' && recipients.length === 0),
                      }}
                    />
                  )}
                  sx={{ mt: 2 }}
                />
              </Grid>
              <Grid item xs={1.5} style={{ paddingTop: 0 }}>
                <LoadingButton
                  fullWidth
                  sx={{ ml: 0, mr: 0, mt: 3 }}
                  loading={myLoader}
                  variant="contained"
                  color="success"
                  onClick={handleSubmit}
                >
                  {myLoader ? 'Loading...' : 'Submit'}
                </LoadingButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default ReportFilter;